'use client';

import { c as _c } from "react/compiler-runtime";
import { usePackagingTypes } from '@repo/features/packaging';
import { z } from '@repo/schema';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
export const PackagingTypeInput = t0 => {
  const $ = _c(31);
  const {
    className,
    "data-testid": dataTestId,
    isPending: t1,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "Select packaging type" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  const {
    data: packagingTypes,
    isPending: isLoading
  } = usePackagingTypes();
  const t4 = isPending || isLoading;
  let t5;
  if ($[0] !== packagingTypes) {
    t5 = packagingTypes?.map(_temp) ?? [];
    $[0] = packagingTypes;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== field) {
    t6 = value => field.handleChange(z.coerce.number().parse(value));
    $[2] = field;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== field.state.value) {
    t7 = field.state.value?.toString();
    $[4] = field.state.value;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== className) {
    t8 = cn("flex justify-between gap-2", className);
    $[6] = className;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = dataTestId ?? "form-packaging-type-select-trigger";
  let t10;
  if ($[8] !== placeholder) {
    t10 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="packaging-type-input.tsx" />;
    $[8] = placeholder;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== isLoading || $[11] !== isPending) {
    t11 = (isPending || isLoading) && <Spinner className="text-muted-foreground ml-auto size-4" />;
    $[10] = isLoading;
    $[11] = isPending;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== field.name || $[14] !== t10 || $[15] !== t11 || $[16] !== t8 || $[17] !== t9 || $[18] !== variant) {
    t12 = <SelectTrigger className={t8} data-testid={t9} id={field.name} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="packaging-type-input.tsx">{t10}{t11}</SelectTrigger>;
    $[13] = field.name;
    $[14] = t10;
    $[15] = t11;
    $[16] = t8;
    $[17] = t9;
    $[18] = variant;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== packagingTypes) {
    t13 = packagingTypes?.map(_temp2);
    $[20] = packagingTypes;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13) {
    t14 = <SelectContent data-sentry-element="SelectContent" data-sentry-source-file="packaging-type-input.tsx">{t13}</SelectContent>;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t14 || $[26] !== t4 || $[27] !== t5 || $[28] !== t6 || $[29] !== t7) {
    t15 = <Select disabled={t4} items={t5} onValueChange={t6} value={t7} data-sentry-element="Select" data-sentry-component="PackagingTypeInput" data-sentry-source-file="packaging-type-input.tsx">{t12}{t14}</Select>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  return t15;
};
function _temp(type) {
  return {
    label: type.title,
    value: type.id.toString()
  };
}
function _temp2(type_0) {
  return <SelectItem key={type_0.id} value={type_0.id.toString()}>{type_0.title}</SelectItem>;
}